import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ServiceService } from '../../service.service';
import { ApiService } from '../../core/api.service';
import { endPoints } from '../../core/Apis/apiEndpoints';

@Component({
  selector: 'app-create-temp-user',
  templateUrl: './create-temp-user.component.html',
  styleUrls: ['./create-temp-user.component.css']
})
export class CreateTempUserComponent implements OnInit {
  creationForm: FormGroup;
  
  // Toast message properties
  toastMessage: string = '';
  toastType: 'success' | 'error' = 'success';
  toastTimeout: any;

  // Form data model
  // Form data model
data = {
  employee_name: "",
  department: "",
  department_id: "",
  username: "",
  password: "",
  confirmPassword: "",  
  workin_time: "09:00",
  workout_time: "18:00",
  weekly_working_days: [] as string[],  
  user_type: "",
  is_department_specific: false,
  is_location_restricted: false,
  sales_qualify_value: 80,
  visits_qualify_value: 5,
  has_visitplan_kpi: false,
  visitplan_waiting_qualify_value: 0,
  visitplan_approval_qualify_value: 0,
  is_visit_location_restricted: false,
  is_customer_location_enabled: false,
  is_attendance_exempted: false,
  warehouse_ids: [],
  on_department_warehouse: false
};

  // Validation errors
  employee_name_error = "";
  department_error = "";
  username_error = "";
  password_error = "";
  user_type_error = "";

  // Dropdown data
  departmentDropdown: any = [];
  userTypedropdown: any = [];

  // Employee search
  employee: any = [];
  isShownEmployee = false;

  // Password visibility
  showPassword = false;
  showConfirmPassword = false;
  doesntMatch = "";

  // Weekly days
  weeKDays = [
    { week: 'Monday', value: 'Monday', checked: false },
    { week: 'Tuesday', value: 'Tuesday', checked: false },
    { week: 'Wednesday', value: 'Wednesday', checked: false },
    { week: 'Thursday', value: 'Thursday', checked: false },
    { week: 'Friday', value: 'Friday', checked: false },
    { week: 'Saturday', value: 'Saturday', checked: false },
    { week: 'Sunday', value: 'Sunday', checked: false }
  ];

  selectedWeek: string[] = [];

  constructor(
    private userService: ServiceService,
    private formBuilder: FormBuilder,
    private apiService: ApiService
  ) {
    this.creationForm = this.formBuilder.group({
      workin_time: ['09:00'],
      workout_time: ['18:00'],
      is_department_specific: [false],
      is_customer_location_enabled: [false],
      is_location_restricted: [false],
      is_visit_location_restricted: [false],
      is_attendance_exempted: [false],
      has_visitplan_kpi: [false],
      sales_qualify_value: [80],
      visits_qualify_value: [5],
      visitplan_waiting_qualify_value: [0],
      visitplan_approval_qualify_value: [0],
      on_department_warehouse: [false],
      warehouse_ids: [[]]
    });
  }

  ngOnInit(): void {
    this.getUsertype();
    this.fetchFactoryDepartment();
  }

  // Show toast message
  showToast(type: 'success' | 'error', message: string) {
    if (this.toastTimeout) {
      clearTimeout(this.toastTimeout);
    }
    this.toastType = type;
    this.toastMessage = message;
    this.toastTimeout = setTimeout(() => {
      this.closeToast();
    }, 5000);
  }

  closeToast() {
    this.toastMessage = '';
    if (this.toastTimeout) {
      clearTimeout(this.toastTimeout);
    }
  }

  // Toggle password visibility
  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  // Get user types
  getUsertype() {
    this.userService.usertypeDropdown().subscribe((res) => {
      this.userTypedropdown = res.data;
    });
  }

  // Get departments
  fetchFactoryDepartment() {
    this.apiService.get(endPoints.factoryDepartment, '/api/dropdown').subscribe({
      next: (value) => {
        this.departmentDropdown = value.data;
      },
      error: (err) => {
        console.error('Error fetching departments:', err);
      }
    });
  }

  // Search employee
  SearchEmployee() {
    if (this.data.employee_name && this.data.employee_name !== '') {
      this.isShownEmployee = true;
      this.userService.SearchEmployee(this.data.employee_name).subscribe((res) => {
        this.employee = res.data;
      });
    }
  }

  // Get selected employee
  getEmployeeId(value1: any, value2: any) {
    this.isShownEmployee = false;
    this.data.employee_name = value2;
    this.data.department_id = value1;
    this.employee_name_error = "";
  }

  // Week selection
  weekSelected(value: string) {
    if (this.selectedWeek.includes(value)) {
      const index = this.selectedWeek.indexOf(value);
      if (index > -1) {
        this.selectedWeek.splice(index, 1);
      }
    } else {
      this.selectedWeek.push(value);
    }
    this.data.weekly_working_days = this.selectedWeek;
  }

  // Value change handlers
  valuechange1(newValue: string) {
    this.data.username = newValue;
    this.username_error = "";
  }

  valuechange2(newValue: string) {
    this.data.password = newValue;
    this.password_error = "";
    if (this.data.password && this.data.confirmPassword && this.data.password !== this.data.confirmPassword) {
      this.doesntMatch = "Passwords don't match";
    } else {
      this.doesntMatch = "";
    }
  }

  valuechange3(newValue: string) {
    this.data.confirmPassword = newValue;
    if (this.data.password && this.data.password !== this.data.confirmPassword) {
      this.doesntMatch = "Passwords don't match";
    } else {
      this.doesntMatch = "";
    }
  }

  valuechange4(newValue: string) {
    this.data.user_type = newValue;
    this.user_type_error = "";
  }

  valuechange5(newValue: string) {
    this.data.employee_name = newValue;
    this.data.department = newValue;
    this.department_error = "";
  }

  // Create temporary user
  // In create-temp-user.component.ts, update the Create() method:

Create() {
  // Validation
  if (!this.data.employee_name || this.data.employee_name === "") {
    this.employee_name_error = "Enter employee name";
    return;
  }
  if (!this.data.username || this.data.username === "") {
    this.username_error = "Enter username";
    return;
  }
  if (!this.data.password || this.data.password === "") {
    this.password_error = "Enter password";
    return;
  }
  if (!this.data.user_type || this.data.user_type === "") {
    this.user_type_error = "Select user type";
    return;
  }
  if (this.data.password !== this.data.confirmPassword) {
    this.doesntMatch = "Passwords don't match";
    return;
  }

  // Prepare request body - Use the typed employee name
  const requestBody = {
    employee_name: this.data.employee_name,  // ← Just the typed name
    username: this.data.username,
    password: this.data.password,
    user_type: this.data.user_type,
    workin_time: "",
    workout_time: "",
    is_department_specific: false,
    is_location_restricted: false,
    is_customer_location_enabled: false,
    weekly_working_days: [],
    is_visit_location_restricted: false
  };

  console.log("Request Body:", requestBody);

  // API call
  this.userService.createTemporaryUser(requestBody).subscribe({
    next: (res: any) => {
      if (res.success) {
        this.showToast('success', res.message || 'Temporary user created successfully!');
        this.resetForm();
      } else {
        this.showToast('error', res.message || 'Failed to create temporary user');
      }
    },
    error: (err) => {
      console.error('Error:', err);
      this.showToast('error', 'An error occurred. Please try again.');
    }
  });
}

  resetForm() {
    this.data = {
      employee_name: "",
      department: "",
      department_id: "",
      username: "",
      password: "",
      confirmPassword: "",
      workin_time: "09:00",
      workout_time: "18:00",
      weekly_working_days: [],
      user_type: "",
      is_department_specific: false,
      is_location_restricted: false,
      sales_qualify_value: 80,
      visits_qualify_value: 5,
      has_visitplan_kpi: false,
      visitplan_waiting_qualify_value: 0,
      visitplan_approval_qualify_value: 0,
      is_visit_location_restricted: false,
      is_customer_location_enabled: false,
      is_attendance_exempted: false,
      warehouse_ids: [],
      on_department_warehouse: false
    };
    this.selectedWeek = [];
    this.weeKDays.forEach(day => day.checked = false);
    this.creationForm.reset({
      workin_time: "09:00",
      workout_time: "18:00",
      is_department_specific: false,
      is_customer_location_enabled: false,
      is_location_restricted: false,
      is_visit_location_restricted: false,
      is_attendance_exempted: false,
      has_visitplan_kpi: false,
      sales_qualify_value: 80,
      visits_qualify_value: 5,
      visitplan_waiting_qualify_value: 0,
      visitplan_approval_qualify_value: 0,
      on_department_warehouse: false,
      warehouse_ids: []
    });
    this.employee_name_error = "";
    this.department_error = "";
    this.username_error = "";
    this.password_error = "";
    this.user_type_error = "";
    this.doesntMatch = "";
  }
}